import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/app' },
  { path: 'login', component: LoginComponent },
  { path: 'app', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  // external
  {
    path: 'external',
    loadChildren: () => import('./external/external.module').then(m => m.ExternalModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
